import React, { Fragment, useEffect } from 'react';
import TobaccoUsage from "../Helpers/TobaccoUsage";
import InsuranceRequest from './InsuranceRequest';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
import { format } from 'date-fns';
import TimeRequiredIcon from "../../../../icons/timeRequired.svg";
import MedicalProcedureIcon from "../../../../icons/medicalProcedure.svg";
import CarrierRatingIcon from "../../../../icons/carrierRating.svg";
import SecureInformationIcon from "../../../../icons/secureInformation.svg";
import { QuoteProductID } from '../QuoteProductID';
import PropTypes from 'prop-types';
import { numbersOnlyString } from '../../../Helpers/Conversion';

function Disclaimer(props) {
  return (<Fragment>
    <p>Disclaimer Agreement: You understand that by clicking on the “I Agree” check box above, you are consenting to Covr Financial Technologies Inc (“Covr”) disclosing Policy Summary Information (as defined below) to the financial institution that referred you to Covr with whom you have an existing relationship. “Policy Summary Information” means the following information received by Covr from Haven Life Insurance Agency, LLC (“Haven Life”) in connection with your inquiry for insurance coverage: (i) your name; (ii) your address; (iii) the fact that you have applied through Haven Life for an insurance product; (iv) the type of policy that you have applied for and the applicable policy limits; and (v) the status of your application for insurance (e.g. pending or issued). The Policy Summary Information shared with the financial Institution will not include your social security number, any financial account numbers, or any “Protected Health Information” (PHI) as defined under HIPAA. </p>
    <p>By clicking Continue, you are providing your signed permission for Covr Financial Technologies to contact you at the email {props.isHavenTermProduct ? 'and' : 'and/or'} telephone number provided, including via text message and live, automated and pre-recorded telephone calls, even if your number is on a Do Not Call list. You also acknowledge that you have received and agree to our Privacy Policy, Terms of Use, and Consent to Do Business Electronically. You may revoke these consents at any time by emailing us at <a href="mailto:support@covrtech.com">SUPPORT@COVRTECH.COM.</a></p>
  </Fragment>);
}

export default function Haven(props) {

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  // pass mike as default submitting agent to haven for time being
  // will be upgraded to use a submitting agent at some point
  const agentFirst = "Mike";
  const agentLast = "Kalen";
  const encodedAgentFirst = encodeURIComponent(agentFirst);
  const encodedAgentLast = encodeURIComponent(agentLast);
  const agentFull = encodedAgentFirst + '+' + encodedAgentLast;

  const havenFormRef = React.createRef();
  const havenTokenRef = React.createRef();
  const selectedQuote = props.formData && props.formData.quoter && props.formData.quoter.selectedQuote;
  const isHavenLifeSIProduct = selectedQuote && selectedQuote.productID === QuoteProductID.HAVEN_SI_PRODUCT_ID;
  const utmSource = isHavenLifeSIProduct ? 'CovrCommission' : accountObj.account.carrierCompensationStructure === 'CovrLeadFee' ? 'Covr' : 'CovrCommission';
  const isHavenTermProduct = selectedQuote && selectedQuote.productID === QuoteProductID.HAVEN_TERM_PRODUCT_ID;

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const havenTermPlanFeatures = [
    {
      icon: TimeRequiredIcon,
      text: "Get your policy today with an all digital process."
    },
    {
      icon: MedicalProcedureIcon,
      text: "Instant decision, no needles or checkups."
    },
    {
      icon: CarrierRatingIcon,
      text: "AM Best has rated this carrier as A++"
    },
    {
      icon: SecureInformationIcon,
      text: "End-to-end 256-bit encryption protects you every step of the way"
    },
  ];

  const havenSIPlanFeatures = [
    {
      icon: TimeRequiredIcon,
      text: "Apply online and, if approved, start coverage immediately"
    },
    {
      icon: CarrierRatingIcon,
      text: "AM Best has rated this carrier as A++"
    },
    {
      icon: SecureInformationIcon,
      text: "End-to-end 256-bit encryption protects you every step of the way."
    },
  ];

  const submitForm = (email, phone) => {
    const formattedDate = format(new Date(props.basicInfo.birthdate), 'MM-dd-yyyy');

    const queryParams = new URLSearchParams({
      face: props.formData.quoter.coverageAmount,
      term: props.formData.quoter.term || props.formData.quoter.termLength,
      stateCode: props.basicInfo.state,
      birthdate: formattedDate,
      healthClass: props.formData.quoter.healthClass,
      gender: props.basicInfo.gender,
      tobacco: TobaccoUsage(props.basicInfo.tobacco) === 'true',
      premium: props.formData.quoter.selectedQuote.monthlyRate,
      email: email,
      phone: numbersOnlyString(phone),
      sessionId: accountObj.sessionId,
      compStructure: isHavenLifeSIProduct ? 'CovrCommission' : accountObj.account.carrierCompensationStructure,
    });

    fetch(`api/HavenLife/AppPreFill?${queryParams.toString()}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
      .then((response) => {
        return response.text();
      })
      .then((jwt) => {
        havenTokenRef.current.value = jwt;
        sessionStorage.removeItem(SESSION_STORAGE_ACCOUNT_KEY);
        havenFormRef.current.submit();
      });
  };

  const onHavenSubmit = (email, firstName, lastName, phone) => {
    props.logQuote(email, firstName, lastName, props.formData.quoter, isHavenTermProduct ? 58 : 60, null, phone).then(() => {
        submitForm(email, phone);
      });

  };

  return <Fragment>
    <InsuranceRequest
      quoterFormState={props.formData.quoter}
      disclaimer={<Disclaimer isHavenLifeSIProduct={isHavenLifeSIProduct} />}
      planFeature={isHavenLifeSIProduct ? havenSIPlanFeatures : havenTermPlanFeatures}
      enablePhone={isHavenLifeSIProduct}
      basicInfo={props.basicInfo}
      isHavenLifeSIProduct={isHavenLifeSIProduct}
      isHavenTermProduct={isHavenTermProduct}
      onBack={props.onBack}
      onSubmit={onHavenSubmit}
      showCustomizeTermModal={props.showCustomizeTermModal}
    />
   <form id="havenPostForm"
    action={isHavenLifeSIProduct ? `https://simple.havenlife.com/amorphic/init/haven-simple.js?utm_source=${utmSource}&utm_campaign=${agentFull}`: `https://havenlife.com/amorphic/init/haven.js?utm_source=${utmSource}&utm_campaign=${accountObj.account.accountName}`}
    method="post" ref={havenFormRef}>
       <input type="hidden" name="token" value="" ref={havenTokenRef} />
      <input type="hidden" name="source" value={utmSource} />
      <input type="hidden" name="version" value="2.0" />
    </form>
  </Fragment>;
}

Haven.propTypes = {
  formData: PropTypes.object,
  onBack: PropTypes.func,
  logQuote: PropTypes.func,
  basicInfo: PropTypes.object,
  showCustomizeTermModal: PropTypes.bool,
};

Disclaimer.propTypes = {
  isHavenTermProduct: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/InsuranceRequest/Haven.js